

















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

@Component
export default class CustomToggle extends Vue {
  @Prop()
  private value!: boolean;

  @Prop()
  private label!: string;

  @Prop({ default: false })
  private disabled!: boolean;

  private get toggleValue(): boolean {
    return this.value;
  }

  @Emit('change')
  private change(value: boolean): boolean {
    return value;
  }
}
